<app-invoice-info [invoiceInfo]="invoiceInfo"></app-invoice-info>